import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UserSettingsHttpService, Campus, NotificationSubscription } from '../../../../../app/core/user-settings';
import { Cache, Auth } from 'aws-amplify';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { NotifyDialogComponent } from './notify-dialog/notify-dialog.component';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { FilterParams } from '../../../../core/filter-options/filter-options.service';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

	topics: any = {};

	user;

	selectedCode: any;

	show = 'alerts';

	summaryReport = false;

	listType = '';

	machines = [];
	clients = [];

	regions = [];
	distis = [];
	markets = [];

	optReg = '';

	territories = [];
	campuses = [];

	subs;

	optTerr = '';

	role;

	listOpt = [];

	unSubs = false;

	private dialogConfig = new MatDialogConfig();

	loadDialog;

	userDbAttr;

	addedRegions: any[] = [];
	addedTerritories: any[] = [];
	addedMachines: any[] = [];

	// Subscriptions tab properties
	loadingSubscriptions: boolean = false;
	analyticsSubscribed: boolean = false;
	stockoutSubscribed: boolean = false;
	stockoutMode: 'daily' | 'on-demand' = 'on-demand';
	stockoutIsOnDemand: boolean = true; // Boolean for toggle binding
	stockoutThreshold: number = 7;
	selectedCampusIds: string[] = [];
	filteredCampuses: Campus[] = [];
	campusSelectOptions: SelectOption[] = [];
	campusDropdownValue: (string | number)[] = []; // Track dropdown selection separately (will be cleared after adding)
	allLoadedCampuses: Campus[] = []; // Keep track of all campuses ever loaded (for displaying selected campuses not in current filter)
	loadingCampuses: boolean = false;
	originalSubscriptionData: any = null;
	userId: string = null;
	hasChanges: boolean = false;

	// Distributor selection properties (for superadmin)
	selectedDistributorIds: string[] = [];
	distributorSelectOptions: SelectOption[] = [];
	distributorDropdownValue: (string | number)[] = [];
	loadingDistributors: boolean = false;
	allDistributors: any[] = [];

	// Hierarchical filter properties
	hierarchicalFilterParams: FilterParams = {
		disti_id: null,
		market_id: null,
		client_id: null,
		campus_id: null
	};



	constructor(
		private http: UserSettingsHttpService,
		private cdr: ChangeDetectorRef,
		public dialog: MatDialog,
		private _snackBar: MatSnackBar,
		private mixPanelService: MixpanelService
	) { }

	ngOnInit() {
		this.user = Cache.getItem('userAttr');
		this.role = this.user['custom:role'];
		this.getUserAttr();
		this.getDistributors();
		this.getExistingSubs();
		this.topics.errors = [];
		this.topics.warnings = [];
		this.mixPanelService.track(this.mixPanelService.PAGE_VIEW);

		// Initialize subscriptions tab
		this.getUserId().then(() => {
			this.loadSubscriptions();
		});
		// Load all campuses initially (will be filtered when hierarchical filters change)
		this.loadFilteredCampuses();
		// Load distributors if superadmin
		if (this.role === 'sadmin') {
			this.loadDistributors();
		}
	}

	getUserAttr() {
		this.http.getUserAttr()
		.subscribe((userDbAttr: any) => {
			this.userDbAttr = userDbAttr;
			this.summaryReport = userDbAttr.summary_subs;
		});
	}

	btnTxt() {
		if (this.subs) {
			return 'Update Subscription';
		} else {
			return 'Subscribe';
		}
	}

	subscribe() {
		let topic_id = [];
		console.log(this.topics.errors);

		for (let eTopic of this.topics.errors) {
			if (eTopic.checked) {
				let topics = (eTopic.log_code.split(','));
				// tslint:disable-next-line: prefer-for-of
				for (let i = 0; i < topics.length; i++) {
					topic_id.push(topics[i]);
				}
			}
		}

		for (let wTopic of this.topics.warnings) {
			if (wTopic.checked) {
				let topics = (wTopic.log_code).split(',');
				// tslint:disable-next-line: prefer-for-of
				for (let i = 0; i < topics.length; i++) {
					topic_id.push(topics[i]);
				}
			}
		}

		let postObj = {
			topic_ids: topic_id,
			new: true,
			disti_ids: this.distis,
			market_ids: this.markets,
			client_ids: this.clients,
			campus_ids: this.campuses,
			subs_arn: null
		};

		if (this.subs) {
			postObj.new = false;
			postObj.subs_arn = this.subs.subs_arn;
		}
		// console.log(postObj);

		this.http.postSubscription(postObj)
		.subscribe(data => {
			if (!this.subs) {
				this.dialogConfig.autoFocus = true;
				this.dialogConfig.data = {
					type: 'subs'
				};
				this.dialogConfig.minWidth = '350';
				const dialogRef = this.dialog.open(NotifyDialogComponent, this.dialogConfig);
				dialogRef.afterClosed().subscribe(res => {
					this.getExistingSubs();
				});
			} else {
				this.showSnackBar('Subscription updated Successfully', 0);
			}
		}, error => {
			console.log(error);
		});
	}

	getExistingSubs() {
		this.http.getExistingSubsDet()
		.subscribe(subs => {
			console.log(subs);
			this.subs = subs;
			this.getTopics();
		});
	}

	sumRepClicked() {
		this.http.updateSummaryReport(this.summaryReport)
		.subscribe(result => {
			if (this.summaryReport) {
				this.showSnackBar('Summary Report Subscribed', 6000);
			} else {
				this.showSnackBar('Summary Report Unsubscribed', 6000);
			}
		});
	}

	// getRegions() {
	// 	if (this.role.includes('rmgr')) {
	// 		// this.regions.push(this.user['custom:region_id']);
	// 		this.regions = (this.user['custom:region_id']).split(',');
	// 	} else if (this.role.includes('admin')) {
	// 		this.http.getRegions()
	// 		.subscribe((regions: any[]) => {
	// 			for (let reg of regions) {
	// 					this.regions.push(reg.region_id);
	// 			}
	// 		});
	// 	}
	// }

	getDistributors() {
		if(this.role == 'sadmin') {
			this.distis = [];
			// this.http.getDistis()
			// .subscribe((distis: any[]) => {
			// 	for(let dist of distis)
			// 		this.distis.push(dist.disti_id);
			// });
		} else {
			console.log(this.user);

			this.distis = (this.user['custom:disti_id']).split(',');
			this.getMarkets();
			this.getClients();
		}
	}

	getMarkets() {
		if (this.user['custom:market_id']) {
			this.markets = (this.user['custom:market_id']).split(',');
		}
	}

	getClients() {
		if (this.user['custom:client_id']) {
			this.clients = (this.user['custom:client_id']).split(',');
			this.getCampus();
		}
	}

	getCampus() {
		if (this.user['custom:campus_id']) {
			this.campuses = (this.user['custom:campus_id']).split(',');
		}
	}

	getTopics() {
		this.topics.errors = [];
		this.topics.warnings = [];
		this.http.getTopics()
		.subscribe((data: any[]) => {
			console.log(data);
			for (let item of data) {
				if (item.log_msg.includes(' error occurred')) {
					item.log_msg = item.log_msg.replace(' error occurred', '');
				}
				if (item.log_msg.includes(' warning occurred')) {
					item.log_msg = item.log_msg.replace(' warning occurred', '');
				}
				if (item.disp) {
					if (item.log_code.startsWith('e0')) {
						if (this.subs) {
							if (!this.subs.event_codes.includes(item.log_code)) {
								this.topics.errors.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
							} else {
								this.unSubs = true;
								this.topics.errors.push({log_code: item.log_code, log_msg: item.log_msg, checked: true});
							}
						} else {
							this.topics.errors.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
						}
					} else if (item.log_code.startsWith('w0')) {
						if(item.log_code != 'w000001' || this.role == 'sadmin'){
							if (this.subs) {
								if (!this.subs.event_codes.includes(item.log_code)) {
									this.topics.warnings.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
								} else {
									this.unSubs = true;
									this.topics.warnings.push({log_code: item.log_code, log_msg: item.log_msg, checked: true});
								}
							} else {
								this.topics.warnings.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
							}
						}
					}
				}
				// else {
				// 	if (this.role.includes('admin')) {
				// 		if (item.log_code.startsWith('e0')) {
				// 			this.topics.errors.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
				// 		} else if (item.log_code.startsWith('w0')) {
				// 			this.topics.warnings.push({log_code: item.log_code, log_msg: item.log_msg, checked: false});
				// 		}
				// 	}
				// }
			}
			this.cdr.detectChanges();
		});
	}

	checkBoxClicked() {
		if (JSON.stringify(this.topics).includes('true')) {
			this.unSubs = true;
		} else {
			this.unSubs = false;
		}
	}

	clearAll() {
		for (let eTopic of this.topics.errors) {
			eTopic.checked = false;
		}
		for (let wTopic of this.topics.warnings) {
			wTopic.checked = false;
		}
		this.unSubs = false;
	}

	unSubscribe() {
		if (this.subs) {
			this.dialogConfig.autoFocus = true;
			this.dialogConfig.data = {
				type: 'unSubs'
			};
			this.dialogConfig.minWidth = '350';
			const dialogRef = this.dialog.open(NotifyDialogComponent, this.dialogConfig);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				} else {
					if (res.success) {
						// Unsubscribe from all alert
						let postObj = {
							topic_ids: [],
							new: false,
							machine_ids: [],
							disti_ids: this.distis,
							market_ids: this.markets,
							client_ids: this.clients,
							campus_ids: this.campuses,
							subs_arn: this.subs.subs_arn
						};

						console.log(postObj);
						this.http.postSubscription(postObj)
						.subscribe(data => {
							console.log(data);
							this.getExistingSubs();
							this.showSnackBar('Unsubscribed Successfully', 0);
							this.cdr.detectChanges();
						}, error => {
							this.showSnackBar('Unable to unsubscribe', 0);
							console.log(error);
						});
					}
				}
			});
		}
	}

	enableLoadDialog() {
		this.dialogConfig.data = {
				type: 'load'
		};
		this.loadDialog = this.dialog.open(NotifyDialogComponent, this.dialogConfig);
	}

	disableLoadDialog() {
		if (this.loadDialog) {
			this.loadDialog.close();
		}
	}


		/**
	  * @param message Message to display in snackbar.
	  * @param duration No of seconds to show, If 0 it will not disappear.
	  */

	 showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

	// Subscriptions tab methods
	getUserId(): Promise<void> {
		return Auth.currentAuthenticatedUser()
			.then(user => {
				if (user && user.attributes && user.attributes.sub) {
					this.userId = user.attributes.sub;
					console.log('User ID loaded:', this.userId);
				} else if (user && user.username) {
					// Fallback to username if sub is not available
					this.userId = user.username;
					console.log('Using username as userId:', this.userId);
				} else {
					console.error('Could not get user ID from authenticated user');
				}
			})
			.catch(err => {
				console.error('Error getting authenticated user:', err);
				// Try currentUserInfo as fallback
				return Auth.currentUserInfo()
					.then(userInfo => {
						if (userInfo && userInfo.attributes && userInfo.attributes.sub) {
							this.userId = userInfo.attributes.sub;
							console.log('User ID loaded from currentUserInfo:', this.userId);
						} else {
							console.error('Could not get user ID from currentUserInfo either');
						}
					})
					.catch(error => {
						console.error('Error getting user info:', error);
					});
			});
	}

	loadSubscriptions() {
		if (!this.userId) {
			console.warn('Cannot load subscriptions: userId not available');
			return;
		}

		this.loadingSubscriptions = true;
		console.log('Loading subscriptions for userId:', this.userId);
		this.http.getNotifications(this.userId)
			.subscribe(
				(data: NotificationSubscription | null) => {
					this.loadingSubscriptions = false;
					console.log('Subscriptions data received:', data);
					if (data === null || !data) {
						// No subscription exists, treat as both disabled
						this.analyticsSubscribed = false;
						this.stockoutSubscribed = false;
						this.stockoutMode = 'on-demand';
						this.stockoutIsOnDemand = true;
						this.stockoutThreshold = 7;
						this.selectedCampusIds = [];
						if (this.role === 'sadmin') {
							this.selectedDistributorIds = [];
						}
						this.originalSubscriptionData = null;
					} else {
						// Map API response to component state
						this.analyticsSubscribed = data.analyticsSubscribed || false;
						this.stockoutSubscribed = data.stockoutSubscribed || false;

						// Determine stockout mode based on threshold
						if (data.stockoutAlertThreshold !== null && data.stockoutAlertThreshold !== undefined) {
							this.stockoutMode = 'on-demand';
							this.stockoutIsOnDemand = true;
							this.stockoutThreshold = data.stockoutAlertThreshold;
						} else {
							this.stockoutMode = 'daily';
							this.stockoutIsOnDemand = false;
							this.stockoutThreshold = 7;
						}

						// Normalize campus IDs to strings for consistency
						this.selectedCampusIds = (data.campusIds || []).map(id => String(id));

						// Load distributor IDs if available (for superadmin)
						if (this.role === 'sadmin') {
							// Handle both distiIds and disti_ids for backward compatibility
							const distiIds = (data as any).distiIds || (data as any).disti_ids;
							if (distiIds) {
								this.selectedDistributorIds = (distiIds || []).map(id => String(id));
							} else {
								this.selectedDistributorIds = [];
							}
							// Update dropdown options to exclude selected distributors (only if distributors are loaded)
							if (this.allDistributors.length > 0) {
								this.updateDistributorSelectOptions();
							}
						}

						this.hierarchicalFilterParams = {
							disti_id: null,
							market_id: null,
							client_id: null,
							campus_id: null
						};

						// Reload campuses without filters to show all available campuses
						this.loadFilteredCampuses();

						this.originalSubscriptionData = JSON.parse(JSON.stringify(data));
					}
					this.checkForChanges();
					this.cdr.detectChanges();
				},
				error => {
					this.loadingSubscriptions = false;
					this.showSnackBar('Failed to load subscriptions', 0);
					console.error('Error loading subscriptions:', error);
					this.cdr.detectChanges();
				}
			);
	}

	onHierarchicalFilterChange(params: FilterParams): void {
		this.hierarchicalFilterParams = params;
		this.loadFilteredCampuses();
		this.cdr.detectChanges();
	}

	private extractSingleValue(value: (string | number) | (string | number)[] | null): string | null {
		if (!value) {
			return null;
		}
		const singleValue = Array.isArray(value) ? value[0] : value;
		return singleValue ? String(singleValue) : null;
	}

	private buildCampusQueryParams(): any {
		const queryParams: any = {};

		const distiId = this.extractSingleValue(this.hierarchicalFilterParams.disti_id);
		if (distiId) {
			queryParams.disti_id = distiId;
		}

		const marketId = this.extractSingleValue(this.hierarchicalFilterParams.market_id);
		if (marketId) {
			queryParams.market_id = marketId;
		}

		const clientId = this.extractSingleValue(this.hierarchicalFilterParams.client_id);
		if (clientId) {
			queryParams.client_id = clientId;
		}

		return queryParams;
	}

	private transformCampuses(campuses: any[]): Campus[] {
		return (campuses || []).map(campus => ({
			...campus,
			campus_id: String(campus.campus_id)
		}));
	}

	/**
	 * Merge new campuses into allLoadedCampuses, avoiding duplicates
	 */
	private mergeCampusesIntoAllLoaded(newCampuses: Campus[]): void {
		const existingCampusIds = new Set(this.allLoadedCampuses.map(c => String(c.campus_id)));
		newCampuses.forEach(campus => {
			if (!existingCampusIds.has(String(campus.campus_id))) {
				this.allLoadedCampuses.push(campus);
			}
		});
	}

	/**
	 * Update campusSelectOptions by filtering out already-selected campuses
	 */
	private updateCampusSelectOptions(): void {
		const selectedCampusIdsSet = new Set(this.selectedCampusIds.map(id => String(id)));
		this.campusSelectOptions = this.filteredCampuses
			.filter(campus => !selectedCampusIdsSet.has(String(campus.campus_id)))
			.map(campus => ({
				value: campus.campus_id,
				label: campus.name
			}));
	}

	loadFilteredCampuses(): void {
		this.loadingCampuses = true;

		const queryParams = this.buildCampusQueryParams();

		this.http.getCampus(queryParams)
			.subscribe(
				(campuses: Campus[]) => {
					this.loadingCampuses = false;

					// Transform and store filtered campuses
					this.filteredCampuses = this.transformCampuses(campuses);

					// Merge into allLoadedCampuses for name resolution
					this.mergeCampusesIntoAllLoaded(this.filteredCampuses);

					// Update dropdown options (excluding already-selected campuses)
					this.updateCampusSelectOptions();

					// Ensure dropdown value is always empty (no state stored)
					this.campusDropdownValue = [];

					this.checkForChanges();
					this.cdr.detectChanges();
				},
				error => {
					this.loadingCampuses = false;
					console.error('Error loading campuses:', error);
					this.cdr.detectChanges();
				}
			);
	}

	onAnalyticsChange() {
		this.checkForChanges();
	}

	onStockoutChange() {
		this.checkForChanges();
	}

	onTabChange(event: any) {
		// Load subscriptions when Subscriptions tab is selected (index 1)
		if (event.index === 1 && !this.loadingSubscriptions && !this.originalSubscriptionData) {
			if (this.userId) {
				this.loadSubscriptions();
			} else {
				this.getUserId().then(() => {
					this.loadSubscriptions();
				});
			}
		}
	}

	onStockoutModeChange() {
		// Update the boolean property based on the mode
		this.stockoutIsOnDemand = this.stockoutMode === 'on-demand';
		if (this.stockoutMode === 'daily') {
			this.stockoutThreshold = 7; // Clear threshold when switching to daily
		}
		this.checkForChanges();
	}

	onThresholdChange() {
		this.checkForChanges();
	}

	onCampusSelectionChange() {
		// Normalize campus IDs to strings for consistency
		this.selectedCampusIds = this.selectedCampusIds.map(id => String(id));
		this.checkForChanges();
	}

	/**
	 * Handle immediate campus selection change (fires on option click)
	 * Adds selected campus to chips immediately and clears dropdown
	 */
	onCampusImmediateSelect(values: (string | number) | (string | number)[] | null): void {
		if (values === null) {
			return;
		}

		// Get the selected campus ID (single select mode)
		const campusId = Array.isArray(values) && values.length > 0
			? String(values[0])
			: String(values);

		// Add to chips if not already selected
		const existingIds = new Set(this.selectedCampusIds.map(id => String(id)));
		if (!existingIds.has(campusId)) {
			this.selectedCampusIds = this.selectedCampusIds.concat([campusId]);
			// Remove from dropdown options so it doesn't appear again
			this.campusSelectOptions = this.campusSelectOptions.filter(opt => String(opt.value) !== campusId);
			this.checkForChanges();
			this.cdr.detectChanges();
		}

		// Clear dropdown selection immediately
		setTimeout(() => {
			this.campusDropdownValue = [];
			this.cdr.detectChanges();
		}, 0);
	}

	/**
	 * Handle campus selection change from searchable-select component (fires when dropdown closes)
	 * Ensures dropdown is cleared
	 */
	onCampusSelectChange(values: (string | number) | (string | number)[] | null): void {
		// Ensure dropdown is cleared
		this.campusDropdownValue = [];
		this.cdr.detectChanges();
	}

	/**
	 * Get display value for campus searchable-select
	 */
	getCampusDisplay(selected: SelectOption[]): string {
		if (selected.length === 0) {
			return 'All Campuses';
		}
		if (selected.length <= 3) {
			return selected.map(s => s.label).join(', ');
		}
		return selected.length + ' selected';
	}

	removeCampus(campusId: string) {
		// Normalize to string for comparison
		const normalizedId = String(campusId);
		this.selectedCampusIds = this.selectedCampusIds.filter(id => String(id) !== normalizedId);
		this.checkForChanges();
		this.cdr.detectChanges();
	}

	/**
	 * Find a campus in an array by ID (handles string/number ID matching)
	 */
	private findCampusById(campuses: Campus[], campusId: string): Campus | null {
		if (!campuses || campuses.length === 0) {
			return null;
		}
		const normalizedId = String(campusId);
		return campuses.find(c =>
			String(c.campus_id) === normalizedId ||
			c.campus_id === campusId ||
			Number(c.campus_id) === Number(campusId)
		) || null;
	}

	/**
	 * Get campus name by ID, searching through all loaded campuses
	 */
	getCampusName(campusId: string): string {
		if (!campusId) {
			return String(campusId);
		}

		// Try filteredCampuses first (current filter results)
		let campus = this.findCampusById(this.filteredCampuses, campusId);
		if (campus) {
			return campus.name;
		}

		// Try allLoadedCampuses (all campuses ever loaded, including from previous filters)
		campus = this.findCampusById(this.allLoadedCampuses, campusId);
		if (campus) {
			return campus.name;
		}

		// Fallback: return the ID as string if campus not found
		return String(campusId);
	}

	updateDistributorSelectOptions(): void {
		const selectedDistributorIdsSet = new Set(this.selectedDistributorIds.map(id => String(id)));
		// Create new array reference so Angular change detection picks it up
		this.distributorSelectOptions = this.allDistributors
			.filter(dist => !selectedDistributorIdsSet.has(String(dist.disti_id)))
			.map(dist => ({
				value: dist.disti_id,
				label: dist.name
			}))
			.sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically
	}

	checkForChanges() {
		if (!this.originalSubscriptionData) {
			// If no original data, check if anything is set
			// Note: hasChanges doesn't validate campus selection - that's done on save
			this.hasChanges = this.analyticsSubscribed || this.stockoutSubscribed ||
				(this.stockoutSubscribed && this.selectedCampusIds.length > 0) ||
				(this.stockoutSubscribed && this.stockoutIsOnDemand && this.stockoutThreshold !== 7) ||
				(this.role === 'sadmin' && this.analyticsSubscribed && this.selectedDistributorIds.length > 0);
			return;
		}

		// Compare current state with original
		const original = this.originalSubscriptionData;

		const analyticsChanged = this.analyticsSubscribed !== original.analyticsSubscribed;
		const stockoutChanged = this.stockoutSubscribed !== original.stockoutSubscribed;

		// Compare campus IDs (arrays)
		const originalCampusIds = (original.campusIds || []).map(id => String(id)).sort();
		const currentCampusIds = this.selectedCampusIds.map(id => String(id)).sort();
		const campusIdsChanged = JSON.stringify(currentCampusIds) !== JSON.stringify(originalCampusIds);

		// Compare threshold and mode
		const originalThreshold = original.stockoutAlertThreshold;
		const originalIsOnDemand = (originalThreshold !== null && originalThreshold !== undefined);
		const thresholdChanged = this.stockoutIsOnDemand !== originalIsOnDemand ||
			(this.stockoutIsOnDemand && this.stockoutThreshold !== originalThreshold);

		// Compare distributor IDs (for superadmin)
		let distributorIdsChanged = false;
		if (this.role === 'sadmin') {
			// Handle both distiIds and disti_ids for backward compatibility
			const originalDistiIds = (original as any).distiIds || (original as any).disti_ids;
			const originalDistributorIds = (originalDistiIds || []).map(id => String(id)).sort();
			const currentDistributorIds = this.selectedDistributorIds.map(id => String(id)).sort();
			distributorIdsChanged = JSON.stringify(currentDistributorIds) !== JSON.stringify(originalDistributorIds);
		}

		this.hasChanges = analyticsChanged || stockoutChanged || campusIdsChanged || thresholdChanged || distributorIdsChanged;
	}

	loadDistributors(): void {
		if (this.role !== 'sadmin') {
			return;
		}

		this.loadingDistributors = true;
		this.http.getDistis()
			.subscribe(
				(distributors: any[]) => {
					this.loadingDistributors = false;
					this.allDistributors = distributors || [];
					// Update dropdown options, excluding any already selected distributors
					this.updateDistributorSelectOptions();
					this.cdr.detectChanges();
				},
				error => {
					this.loadingDistributors = false;
					console.error('Error loading distributors:', error);
					this.cdr.detectChanges();
				}
			);
	}

	onDistributorImmediateSelect(values: (string | number) | (string | number)[] | null): void {
		if (values === null) {
			return;
		}

		// Get the selected distributor ID (single select mode)
		const distributorId = Array.isArray(values) && values.length > 0
			? String(values[0])
			: String(values);

		// Add to chips if not already selected
		const existingIds = new Set(this.selectedDistributorIds.map(id => String(id)));
		if (!existingIds.has(distributorId)) {
			this.selectedDistributorIds = this.selectedDistributorIds.concat([distributorId]);
			// Remove from dropdown options so it doesn't appear again
			this.distributorSelectOptions = this.distributorSelectOptions.filter(opt => String(opt.value) !== distributorId);
			this.checkForChanges();
			this.cdr.detectChanges();
		}

		// Clear dropdown selection immediately
		setTimeout(() => {
			this.distributorDropdownValue = [];
			this.cdr.detectChanges();
		}, 0);
	}

	onDistributorSelectChange(values: (string | number) | (string | number)[] | null): void {
		// Ensure dropdown is cleared
		this.distributorDropdownValue = [];
		this.cdr.detectChanges();
	}

	removeDistributor(distributorId: string) {
		// Normalize to string for comparison
		const normalizedId = String(distributorId);
		this.selectedDistributorIds = this.selectedDistributorIds.filter(id => String(id) !== normalizedId);

		// Update dropdown options - this creates a new array reference so Angular change detection picks it up
		this.updateDistributorSelectOptions();

		this.checkForChanges();
		this.cdr.detectChanges();
	}

	getDistributorName(distributorId: string): string {
		if (!distributorId) {
			return String(distributorId);
		}

		const distributor = this.allDistributors.find(d => String(d.disti_id) === String(distributorId));
		return distributor ? distributor.name : String(distributorId);
	}

	saveSubscriptions() {
		if (!this.userId) {
			this.showSnackBar('User ID not available', 0);
			return;
		}

		// Validation: must select at least one campus if subscribing to stockout alerts
		if (this.stockoutSubscribed && (!this.selectedCampusIds || this.selectedCampusIds.length === 0)) {
			this.showSnackBar('Please select at least one campus for stockout alerts', 0);
			return;
		}

		this.loadingSubscriptions = true;

		const payload: any = {
			user_id: this.userId,
			analytics_subscribed_status: this.analyticsSubscribed,
			stockout_subscribed_status: this.stockoutSubscribed
		};

		if (this.stockoutSubscribed) {
			payload.campus_ids = this.selectedCampusIds;
			payload.stockout_alert_threshold = (this.stockoutMode === 'on-demand')
				? this.stockoutThreshold
				: null;
		} else {
			payload.campus_ids = [];
			payload.stockout_alert_threshold = null;
		}

		// Add distributor IDs for superadmin analytics subscription
		if (this.role === 'sadmin' && this.analyticsSubscribed) {
			payload.disti_ids = this.selectedDistributorIds;
		}

		this.http.updateNotifications(payload)
			.subscribe(
				(response: any) => {
					this.loadingSubscriptions = false;
					this.showSnackBar('Subscriptions updated successfully', 0);
					// Reload subscriptions to update originalSubscriptionData
					this.loadSubscriptions();
				},
				error => {
					this.loadingSubscriptions = false;
					const errorMessage = (error.error && error.error.error) || error.message || 'Failed to update subscriptions';
					this.showSnackBar(errorMessage, 0);
					console.error('Error updating subscriptions:', error);
					this.cdr.detectChanges();
				}
			);
	}
}
